export enum ErrorSeverityLevel {
    Info = 1,
    Warning = 2,
    Error = 3,
    Critical = 4
}
